export const CUSTOM_EVENT_NEW_THEME_APPLIED = "new-theme-applied";
